import React from 'react'
import PropTypes from 'prop-types'

export const LoadingProgress = props => {
  let percentage = (props.current / props.total) * 100
  let loadingStyle = {
    width: `${percentage}%`,
  }

  let progressBarClass =
    percentage === 100 ? 'progress-bar progress-bar-success' : 'progress-bar'
  return (
    <React.Fragment>
      <div className="progress">
        <div
          className={progressBarClass}
          role="progressbar"
          aria-valuenow="60"
          aria-valuemin="0"
          aria-valuemax="100"
          style={loadingStyle}
        >
          {percentage.toFixed(0)}%
        </div>
      </div>
      <span>
        {props.current} of {props.total}
      </span>
    </React.Fragment>
  )
}

LoadingProgress.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
}
